module.exports = __webpack_public_path__ + "img/banner3.5cc99c5e.png";